import type { AdminFunnelPlatform } from '@orbit/api-types'
import { useSearchParams } from 'react-router-dom'
import { platformFromParam, platformSearch } from './funnelView'

/**
 * The funnel's platform, kept in the URL so the funnel and its step lists hand it
 * to each other and the back button restores it. Switching replaces the history
 * entry rather than adding one.
 */
export const usePlatformParam = (): [AdminFunnelPlatform, (next: AdminFunnelPlatform) => void] => {
	const [searchParams, setSearchParams] = useSearchParams()
	const setPlatform = (next: AdminFunnelPlatform) => setSearchParams(platformSearch(next), { replace: true })
	return [platformFromParam(searchParams.get('platform')), setPlatform]
}
